// extracted by mini-css-extract-plugin
export var container = "input-label-module--container--b83b3";
export var disabled = "input-label-module--disabled--738df";
export var error = "input-label-module--error--ace5d";
export var large = "input-label-module--large--93862";
export var text = "input-label-module--text--a3743";